import { withInstall } from '@/utils/index'
import BasicDrawer from './src/BasicDrawer.vue'

export { BasicDrawer }

export default withInstall(BasicDrawer)
